import React from 'react';
import Fetch from '@components/util/Fetch';
import Icon from '@components/shared/icons';
import { logCrmEvent } from '@javascripts/util/eventLogging';
import PropTypes from 'prop-types';
import './styles.scss';

function PledgeFirstTitleBanner({ data }) {
  const { dismissPath, submitPath } = data;

  const handleClick = async () => {
    logCrmEvent('pledge_title_banner_click');
    await Fetch.post({ url: dismissPath });
    window.location = submitPath;
  };

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    logCrmEvent('pledge_title_banner_dismiss');
    const banner = document.getElementById('pledge-first-title-banner-content');
    banner.style.display = 'none';
    Fetch.post({ url: dismissPath });
  };

  return (
    <div
      id="pledge-first-title-banner-content"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      <button
        type="button"
        className="close-pledge-first-title-button"
        onClick={handleClose}
      >
        <Icon type="close" />
      </button>

      <span className="pledge-first-title-text large-bold-font">
        <Icon type="information-circle" />
        Don't let your next closing get delayed. Secure your closing advantages
        early with ReferralExchange Settlement Services.
      </span>
      <button
        type="button"
        className="profile-edit-button submit"
      >
        PLEDGE TITLE NOW
      </button>
    </div>
  );
}

PledgeFirstTitleBanner.propTypes = {
  data: PropTypes.shape({
    dismissPath: PropTypes.string,
    submitPath: PropTypes.string,
  }).isRequired,
};

export default PledgeFirstTitleBanner;
